<template>
  <div id="app" :class="{'screentest': userAgent.screentest}">
    <content-header v-if="!isMobileHeader"></content-header>
    <content-header-mobile v-else></content-header-mobile>
    <router-view/>
    <rotate-lock v-if="userAgent.orientation == 'landscape' && (userAgent.device.isPhone || (userAgent.device.isTablet && userAgent.window.width > 1024))"></rotate-lock>
    <isi/>
    <isi2/>
    <div class="starting_overlay" v-if="this.$route.name !== 'Home' && userAgent.device.isMobile || userAgent.window.width < 1024" :class="{ 'starting_overlay--psoriasis': this.$route.meta.page === 'Psoriasis', 'starting_overlay--tremfya': this.$route.meta.page === 'Tremfya' }"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import handleResize from '@/mixins/handleResize';
import handleScreentest from '@/mixins/handleScreentest';
import handleOrientation from '@/mixins/handleOrientation';
import fixSafariOffset from '@/mixins/fixSafariOffset';
import lockScroll from '@/mixins/lock-scroll';
import rotateLock from '@/components/common-blocks/rotate-lock/rotate-lock';
import VueProgressiveImage from 'vue-progressive-image';
import EmptyProgressiveIMG from '@/components/EmptyProgressiveIMG';
import Isi from '@/components/blocks/Isi_1/Isi_1';
import Isi2 from '@/components/blocks/Isi_2/Isi_2';
import ContentHeader from '@/components/ContentHeader/ContentHeader';
import ContentHeaderMobile from '@/components/ContentHeader/ContentHeaderMobile';
import Vue2TouchEvents from 'vue2-touch-events';
import AnimText from '@/components/AnimText/AnimText';

Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400
});

Vue.component('anim-text', AnimText);

// if its SCREENTEST create empty component except Plugin for lazy load images
if (process.env.VUE_APP_SCREENTEST) {
  const mergeOptions = function(component, options = {}) {
    return {
      ...component,
      data: () => ({ options })
    };
  };
  const EMPTY_PLUGIN = function(Vue, options = {}) {
    Vue.component(
      'progressive-img',
      mergeOptions(EmptyProgressiveIMG, options)
    );
  };
  Vue.use(EMPTY_PLUGIN);
} else {
  Vue.use(VueProgressiveImage, {
    cache: false
  });
}

Vue.mixin(lockScroll); // add global LockScroll mixin

export default {
  components: {
    rotateLock,
    Isi,
    Isi2,
    ContentHeader,
    ContentHeaderMobile
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState(['userAgent']),
    isMobileHeader() {
      let res = false;

      if (this.userAgent.screentest) {
        res = this.userAgent.window.width < 701 ? true : false;
      } else if (this.$store.state.userAgent.device.isMobile) {
        res = true;
      }

      return res;
    }
  },
  mixins: [handleResize, handleOrientation, handleScreentest, fixSafariOffset],
  methods: {},
  mounted() {}
};
</script>


<style lang="scss" src="./styles/main.scss">
</style>
